import { render, staticRenderFns } from "./_ProductList.vue?vue&type=template&id=1cb9bfd6"
import script from "./_ProductList.vue?vue&type=script&lang=js"
export * from "./_ProductList.vue?vue&type=script&lang=js"
import style0 from "./_ProductList.vue?vue&type=style&index=0&id=1cb9bfd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports